<!-- 自定义表单单个组件匹配 -->
<template>
    <a-form-model-item :label="field.fieldName" :ref="field.fieldCode" :prop="field.fieldCode" label-align="left">
        <!-- 编辑模式 -->
        <!--        <span slot="label">-->
        <!--            <Ellipsis style="display: inline" :value="field.fieldName" :length="8" />-->
        <!--        </span>-->
        <template v-if="isFieldEdit">
            <!-- 编辑的时候也要加密字段 -->
            <template v-if="(sdEncryptField[componentName] && encryptFieldInfo && encryptFieldInfo.currentRoleIsEncrypted && isEditFrozen) || field.isPresetEncrypted==1  ">
                <component
                    ref="componentItem"
                    :is="sdEncryptField[componentName]"
                    style="min-width: 180px"
                    :value="value"
                    :field="field"
                    @update:value="updateValue"
                    @onValidate="onValidate"
                    @onEncryptValidate="onEncryptValidate"
                    @blurField="$emit('validateField', field.fieldCode)"
                    @refreshForm="$emit('refreshForm')"
                     @change:fieldCoed="changeFieldCode"
                    :formType="formType" />
            </template>
            <template v-else>
                <component
                    :is="componentName"
                    style="min-width: 180px"
                    :value="value"
                    :field="field"
                    @update:value="updateValue"
                    @onValidate="onValidate"
                    @blurField="$emit('validateField', field.fieldCode)"
                    @refreshForm="$emit('refreshForm')"
                     @change:fieldCoed="changeFieldCode"
                    :formType="formType" />
            </template>
        </template>

        <!-- 查看模式 -->
        <template v-else>
            <!-- 文件类型字段 -->
            <template v-if="field.fieldFormType === 'file'">
                <!-- 多文件展示 -->
                <div v-if="isMultipleFile" style="display: flex; width: 100%; flex-wrap: wrap">
                    <template v-for="(item, index) in value.split(',')">
                        <img :key="index" v-if="getFileType(item) === 'image'" loading="lazy" class="form-item-image" :src="getFileAccessHttpUrl(item, '', formType)" v-viewer />
                        <a v-else class="form-item-file" :href="`${getFileAccessHttpUrl(item, '', formType)}`" target="_blank">
                            <span> <a-icon type="file" />预览 </span>
                        </a>
                    </template>
                </div>
                <template v-else>
                    <img v-if="fileType === 'image'" loading="lazy" class="form-item-image" :src="getFileAccessHttpUrl(value, '', formType)" v-viewer />
                    <a class="form-item-file" v-if="fileType !== 'image' && value" :href="`${getFileAccessHttpUrl(value, '', formType)}`" target="_blank">
                        <span> <a-icon type="file" />预览 </span>
                    </a>
                </template>
            </template>

            <!-- 加密字段 -->
            <template v-else-if="encryptFieldInfo && encryptFieldInfo.currentRoleIsEncrypted">
                <template v-if="value || value === 0">
                    <span  class="text-copy" v-if="encryptFieldInfo.currentRoleIsShowCopyButton" @click="(copyObject)">
                       <span v-if="!isPresetEncrypt"  @click="handleCopy(copyObject)">
                            <a-icon type="copy" />
                            {{ encryptedRender(value) }}
                       
                        </span> 
                        <span v-if="isPresetEncrypt" @click="handlePresetEncryptCopy(copyObject)">
                                <a-icon type="copy"  />
                                {{ encryptedRender(value) }}
                        </span>
                    </span>
                  
                    <span v-else>{{ encryptedRender(value) }}</span>
                </template>
                <template v-else>
                    <span>-</span>
                </template>
            </template>

            <!-- 字段配置：字段可复制 -->
            <template v-else-if="encryptFieldInfo.currentRoleIsShowCopyButton">
                <span v-if="value || value === 0" class="text-copy" @click="handleCopy(copyObject)">
                    <a-icon type="copy" />
                    {{ setOptionsText(value, field) }}
                </span>
                <span v-else>-</span>
            </template>
            <!-- 字段配置：字段可复制 -->
            <template v-else-if="isClipboard">
                <!--  v-clipboard="copyObject" -->
                <span v-if="value || value === 0" class="text-copy" @click="handleCopy(copyObject)">
                    <a-icon type="copy" />
                    {{ setOptionsText(value, field) }}
                </span>
                <span v-else>-</span>
            </template>

            <!-- 退费明细公司字段 -->
            <template v-else-if="field.fieldCode === 'pay_company'">
                <span style="line-height: 21px !important">{{ setPayCompanyOptionsText(value, field) || "-" }}</span>
            </template>

            <!-- 富文本渲染 -->
            <template v-else-if="field.fieldFormType === 'richtext'">
                <span class="richTextBox" v-html="value === 0 ? value : setOptionsText(value, field) || '-'"></span>
            </template>

            <!-- 默认文本 -->
            <template v-else>
                <span style="line-height: 21px !important; white-space: break-spaces; word-break: break-all; font-weight: 400">
                    {{ value === 0 ? value : setOptionsText(value, field) || "-" }}
                </span>
            </template>
        </template>
    </a-form-model-item>
</template>

<script>
import { initDictOptions } from "@/utils/DictUtil";
import { encryptedRender, handleCopy ,handlePresetEncryptCopy} from "@/utils/dynamic";
import { getFileType, getFileAccessHttpUrl, validatorFilterType, getRSAData } from "@/utils/index";
import { SYS_ROLE_ENCRYPT_FIELD } from "@/store/mutation-types";
import Ellipsis from "@/components/Ellipsis";
import moment from "moment";

export default {
    name: "FormItem",
    components: {
        SdDate: () => import(/* webpackChunkName: "SdDate" */ "./DataEntry/SdDate"),
        SdRegion: () => import(/* webpackChunkName: "SdRegion" */ "./DataEntry/SdRegion"),
        SdCascade: () => import(/* webpackChunkName: "SdRegion" */ "./DataEntry/SdCascade"),
        SdCheckbox: () => import(/* webpackChunkName: "SdCheckbox" */ "./DataEntry/SdCheckbox"),
        SdInput: () => import(/* webpackChunkName: "SdInput" */ "./DataEntry/SdInput"),
        SdNumber: () => import(/* webpackChunkName: "SdNumber" */ "./DataEntry/SdNumber"),
        SdRadio: () => import(/* webpackChunkName: "SdRadio" */ "./DataEntry/SdRadio"),
        SdSelect: () => import(/* webpackChunkName: "SdSelect" */ "./DataEntry/SdSelect"),
        SdTextarea: () => import(/* webpackChunkName: "SdTextarea" */ "./DataEntry/SdTextarea"),
        SdTime: () => import(/* webpackChunkName: "SdTime" */ "./DataEntry/SdTime"),
        SdFile: () => import(/* webpackChunkName: "SdFile" */ "./DataEntry/SdFile"),
        SdRichText: () => import(/* webpackChunkName: "SdRichText" */ "./DataEntry/SdRichText"),
        SdEncryptFieldInput: () => import(/* webpackChunkName: "SdEncryptFieldInput" */ "./DataEntry/SdEncryptFieldInput"),
        SdEncryptFieldNumber: () => import(/* webpackChunkName: "SdEncryptFieldNumber" */ "./DataEntry/SdEncryptFieldNumber"),
        SdEncryptFieldTextarea: () => import(/* webpackChunkName: "SdEncryptFieldTextarea" */ "./DataEntry/SdEncryptFieldTextarea"),
        Ellipsis,
    },
    props: {
        value: {
            type: [String, Number],
        },
        field: {
            type: Object,
            required: true,
        },
        // 是否切换为编辑
        isEdit: {
            type: Boolean,
            default: false,
        },
          // 是否是预置加密字段
       isPresetEncrypt: {
                type: Boolean,
                default: false,
            },
               
        // 过滤器类型
        filterType: {
            type: Number,
            required: true,
            validator: validatorFilterType,
        },
        // 表单是否在编辑的时候加密字段
        isEditFrozen: {
            type: Boolean,
            default: false,
        },
        // 客户id，校验唯一字段
        customerId: {
            type: String,
            default: "",
        },
        formType: {
            type: String,
            default: "",
        },
        //加密码
        copyValue: {
            type: String,
            default: "",
        },
    },
    data() {
        return {};
    },
    computed: {
        // 模式：true编辑模式 false查看模式
        isFieldEdit({ $props }) {
            return $props.isEdit && Number($props.field.isModify) === 1 && Number($props.field.isSelectAddEdit) === 1;
        },
        componentName({ $props }) {
            const components = {
                input: "SdInput",
                textarea: "SdTextarea",
                number: "SdNumber",
                select: "SdSelect",
                radio: "SdRadio",
                checkbox: "SdCheckbox",
                date: "SdDate",
                time: "SdTime",
                region: "SdRegion",
                cascade: "SdCascade",
                file: "SdFile",
                richtext: "SdRichText",
            };
            return components[$props.field.fieldFormType];
        },
        // 字段配置：是否可复制-字段维度已废弃
        isClipboard({ $props }) {
            const commonProperties = JSON.parse($props.field.commonProperties || '{"options":{}}');
            return commonProperties.options.clipboard;
        },
        copyObject({ $props }) {
            console.log("🚀 ~ copyObject ~ props:", $props,this.field.copyObject,this.copyValue);
            if (this.copyValue) {
                if($props.field.isPresetEncrypted==1){
                    return {
                        ...(this.field.copyObject || {}),
                        copyFieldValue:  $props.value,
                        content: $props.value,
                    };
                }else{
                        return {
                    ...($props.field.copyObject || {}),
                    copyFieldValue: this.copyValue ? getRSAData(this.copyValue) : this.setOptionsText(this.value, this.field),
                    content: this.copyValue ? getRSAData(this.copyValue) : this.setOptionsText(this.value, this.field),
                };
                }
            
            } else {
                return this.setOptionsText(this.value, this.field);
            }
        },
        // 文件类型
        fileType() {
            if (this.field.fieldFormType === "file" && this.value) {
                return getFileType(this.value) ? getFileType(this.value) : "none";
            } else {
                return "none";
            }
        },
        // 是否是多文件
        isMultipleFile() {
            if (this.field.fieldFormType === "file" && this.value) {
                if (this.value.split(",").length >= 2) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        // 加密字段集合
        encryptFieldList() {
            let encryptFieldList = [];
            try {
                encryptFieldList = JSON.parse(sessionStorage.getItem(SYS_ROLE_ENCRYPT_FIELD));
            } catch (e) {
                console.error(e);
            }
            return encryptFieldList;
        },
        // 字段加密信息
        encryptFieldInfo() {
            const field = this.field;
            // console.log('field',field)
            const encryptFieldInfo = {
                currentRoleIsEncrypted: field.currentRoleIsEncrypted,
                currentRoleIsShowCopyButton: field.currentRoleIsShowCopyButton,
            };
            // console.log(this.field.fieldName, '是否加密', encryptFieldInfo)
            return encryptFieldInfo;
        },
        // 自定义表单需要加密的字段
        sdEncryptField() {
            return {
                SdInput: "SdEncryptFieldInput",
                SdNumber: "SdEncryptFieldNumber",
                SdTextarea: "SdEncryptFieldTextarea",
            };
        },
    },
    methods: {
        getFileAccessHttpUrl,
        getFileType,
        encryptedRender,
        getRSAData,
        handleCopy,
        handlePresetEncryptCopy,
        updateValue(val) {
            this.$emit("update:value", val);
             // 角色未配置预置加密字段也需要触发预置加密字段的校验
             this.$emit('changeFieldCode', this.field.fieldCode)
        },
        changeFieldCode() {
        console.log('changeFieldCode', this.field.fieldCode);
        this.$emit('changeFieldCode', this.field.fieldCode)
      },
        onValidate() {
            this.$emit("validateField", this.field.fieldCode);
        },
        onEncryptValidate() {
            this.$emit("encryptValidateField", this.field.fieldCode);
        },
        validatePromise(val) {
            this.$refs["componentItem"].validatePromise(val);
        },
        setPayCompanyOptionsText(value, field) {
            let text = "";
            const values = value ? value : [];
            const options = JSON.parse(field.options);
            for (let i = 0, len = options.length; i < len; i++) {
                if (values.includes(options[i].value)) {
                    text += `${options[i].label}，`;
                }
            }
            return text.substring(0, text.length - 1);
        },
        setOptionsText(value, field) {
            if (["select", "radio"].includes(field.fieldFormType)) {
                let text = "";
                const values = value ? [Number(value)] : [];
                const options = JSON.parse(field.options);
                for (let i = 0, len = options.length; i < len; i++) {
                    if (values.includes(options[i].value)) {
                        text += `${options[i].label}，`;
                    }
                }
                // console.log("297🚀 ~ setOptionsText ~ text:", text);
                return text.substring(0, text.length - 1);
            } else if (["checkbox"].includes(field.fieldFormType)) {
                let text = "";
                const values = value ? value.split(",").map(Number) : [];
                const options = JSON.parse(field.options);
                for (let i = 0, len = options.length; i < len; i++) {
                    if (values.includes(options[i].value)) {
                        text += `${options[i].label}，`;
                    }
                }
                return text.substring(0, text.length - 1);
            } else if (["region"].includes(field.fieldFormType)) {
                if (value) {
                    try {
                        let regionText = "",
                            regionOptions = JSON.parse(value);
                        regionOptions.forEach((item) => {
                            regionText += `${item.name}/`;
                        });
                        return regionText.substring(0, regionText.length - 1);
                    } catch (e) {
                        return "-";
                    }
                } else {
                    return "-";
                }
            } else if (["date"].includes(field.fieldFormType)) {
                // eslint-disable-next-line no-empty
                if (JSON.parse(field.commonProperties).options.format && value) {
                    return moment(new Date(value.replace(/-/g, "/"))).format(JSON.parse(field.commonProperties).options.format);
                } else {
                    return value;
                }
            } else if (["cascade"].includes(field.fieldFormType)) {
                if (value) {
                    let regionText = "",
                        regionOptions = JSON.parse(value);
                    regionOptions.forEach((item) => {
                        regionText += `${item.label}/`;
                    });
                    return regionText.substring(0, regionText.length - 1);
                } else {
                    return "-";
                }
            } else {
                return value;
            }
        },
        showCallOutReason() {
            // 获取字典值
            initDictOptions("call_out_reason").then((res) => {
                const callOutReasonArr = [];
                res.result.forEach((item) => {
                    callOutReasonArr.push({
                        value: item.value,
                        label: item.title,
                    });
                });
                this.callOutReasonArr = callOutReasonArr;

                this.isShowCallOutReason = true;
            });
        },
    },
    created() {},
    mounted() {},
};
</script>

<style scoped lang="less">
.text-copy {
    white-space: normal;
    display: flex;
    align-items: center;
    /*flex-wrap: wrap;*/
    white-space: break-spaces;
    word-break: break-all;
}

.form-item-image {
    max-width: 50px !important;
    max-height: 50px;
    object-fit: cover;
    cursor: pointer;
    margin-top: 5px;
    margin-right: 5px;
    border-radius: 4px 4px 4px 4px;
}

.form-item-file {
    width: 50px !important;
    height: 50px;
    display: block;
    background: #edf1fd;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-weight: 600;
    color: #557be8;
    margin-top: 5px;
    margin-right: 5px;

    span {
        margin-left: 4px;
    }
}

.form-model-item-review {
}

// 富文本相关
/deep/ .richTextBox {
    p {
        margin-bottom: 0px !important;
    }
}

/deep/ .ant-checkbox-group {
    white-space: break-spaces;
}
</style>
